import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {Scanner3dAccountDataService} from './scanner3dAccountData.service';
import {Scanner3dAccountModel} from '../../../api/entity/scanner3dAccount.model';
import {Scanner3dAccountConverter} from '../../../api/entity/converter/scanner3dAccount.converter';

@Injectable()
export class Scanner3dAccountDataServiceAdapter extends AbstractDataServiceDtoAdapter<Scanner3dAccountModel, Scanner3dAccountConverter> {
    constructor(dataService: Scanner3dAccountDataService, converter: Scanner3dAccountConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): Scanner3dAccountModel {
        return new Scanner3dAccountModel();
    }
}
